import { CsmsEndpointRole } from '@evimo/types/enums/csms-endpoint-role';
import type {
  ExternalCsmsConfigProps,
  ExternalCsmsEndpointProps,
} from '@evimo/core/modules/organization/domain/organization.types';

/**
 * Organization-owned CSMS configuration. Usable Primary and charger
 * authentication are decided here, not by callers.
 */
export class ExternalCsmsConfiguration {
  private constructor(private readonly props: ExternalCsmsConfigProps) {}

  public static create(
    props: ExternalCsmsConfigProps,
  ): ExternalCsmsConfiguration {
    return new ExternalCsmsConfiguration(props);
  }

  public getUsablePrimary(): ExternalCsmsEndpointProps | null {
    const primary = (this.props.endpoints ?? []).find(
      (endpoint) => endpoint.role === CsmsEndpointRole.PRIMARY,
    );
    if (!primary || !primary.enabled || !primary.baseUrl.trim()) {
      return null;
    }
    return primary;
  }

  public isChargerAuthenticationEnabled(): boolean {
    return (
      this.getUsablePrimary() != null &&
      this.props.chargerAuthenticationEnabled === true
    );
  }
}
